import React from "react";
import { useHistory } from "react-router-dom";
import * as Styles from "./Passwort.styles";
import appleStore from "assets/images/health-analyse/apple-store.png";
import googlePlay from "assets/images/health-analyse/google-store.png";
import backIcon from "assets/images/back-icon.svg";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { CLOSE, EMPFEHLUNG } from "routes/routes";
import { useSelector } from "react-redux";

const Passwort = () => {
  const history = useHistory();
  const { registrationData, trainerShowData } = useSelector(
    (state) => state.auth
  );

  const handleBtnClick = () => {
    if (trainerShowData?.businessModelId == 3) {
      history.push(EMPFEHLUNG);
    } else window.open("https://my.foodiary.app/", "_self");
  };

  const EMAIL = registrationData?.email || "";
  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Wir starten!"}
          subHeadline={"Herzlich Willkommen!"}
          handleNextPage={handleBtnClick}
          btnText={
            trainerShowData?.businessModelId == 3
              ? "Gesundheit verbessern"
              : "Lernacademy öffnen"
          }
          noBackButton={true}
        />

        <Styles.ContentSection>
          <h3>Die nächsten Schritte:</h3>

          <Styles.EmailConfirmBox>
            <p>Du erhältst direkt eine E-Mail an {EMAIL}.</p>
            <p className="mt-8">
              Hier findest du den Zugang zur Lernacademy, den Download zur App
              und weitere Informationen.
            </p>
          </Styles.EmailConfirmBox>

          <p className="app-instruction">
            Lade dir direkt unsere App in deinem App Store herunter. Melde dich
            mit deinen Zugangsdaten an und starte deine Ernährungsumstellung.
          </p>

          <h3>Hier findest du die App:</h3>

          <Styles.AppStoreLinks>
            <a
              href="https://apps.apple.com/us/app/foodiary-ern%C3%A4hrungsplaner-app/id1502395764"
              target="_blank"
              className="store-link"
            >
              <img
                src={appleStore}
                alt="Apple App Store"
                width={130}
                height={46}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.foodiary.nutrition&hl=en"
              className="store-link"
              target="_blank"
            >
              <img
                src={googlePlay}
                alt="Google Play Store"
                width={130}
                height={46}
              />
            </a>
          </Styles.AppStoreLinks>
        </Styles.ContentSection>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show "
      >
        {trainerShowData?.businessModelId == 3
          ? "Gesundheit verbessern"
          : "Lernacademy öffnen"}
      </button>
    </Styles.Container>
  );
};

export default Passwort;
